import styled from 'styled-components';
import { SearchIcon } from '../../atoms/icons';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
`;

export const Wrapper = styled.div`
  display: flex;
  align: center;
  cursor: pointer;

  & > svg {
    fill: ${({ theme }) => theme.colors.lightBlue};
  }
`;

export const SearchAction = styled(SearchIcon)`
  height: 18px;
  margin-bottom: 1px;
`;
